<script setup lang="ts">
import { APP_NAME, getPageTitle } from "@/assets/js/appConfig";
import { useDefaultStore } from "@/store";

;

const store = useDefaultStore();

useHead({
	title: getPageTitle("People - Beat The Clock"),
	meta: [
		{ name: "title", content: getPageTitle("People - Beat The Clock") },
		{
			name: "description",
			content: "Beat the timer by guessing which person was born earlier.",
		},
		{ name: "robots", content: "index, follow" },
		{
			property: "og:title",
			content: getPageTitle("People - Beat The Clock"),
		},
		{
			property: "og:description",
			content: "Beat the timer by guessing which person was born earlier.",
		},
		{ property: "og:site_name", content: APP_NAME },
	],
});
</script>

<template>
	<PeopleSinglePlayerGame
		:game-type="store.SINGLE_PLAYER_GAME_TYPES.BEAT_THE_CLOCK"
	/>
</template>
